import axios from "axios";

export function fetchCustomerDetails(queryString) {
    return axios.get(`${process.env.REACT_APP_DD_HOST_URL}/v1/customers${queryString? '?query_string='+ queryString : '' }`);
}